// extracted by mini-css-extract-plugin
module.exports = {"root":"TextInput_root__1UwWN","focused":"TextInput_focused__2iNl6","input":"TextInput_input__l8lj-"};